import { Page } from 'ui';

import { CreatePayouts } from '../../components/CreatePayouts/CreatePayouts';
import { SubmitPaymentRequests } from '../../components/SubmitPaymentRequests/SubmitPaymentRequests';

export const FinancingHome = () => {
  return (
    <Page>
      <SubmitPaymentRequests />
      <CreatePayouts />
    </Page>
  );
};
